export function useReceiptFormatting() {
  const formatDate = (dateString) => {
    if (!dateString) return 'Nicht angegeben'
    try {
      const date = new Date(dateString)
      return date.toLocaleDateString('de-DE')
    } catch (error) {
      return dateString
    }
  }

  const formatAmount = (amount) => {
    return parseFloat(amount || 0).toFixed(2)
  }

  const formatDateTime = (dateString) => {
    if (!dateString) return 'Nicht angegeben'
    try {
      const date = new Date(dateString)
      return date.toLocaleString('de-DE')
    } catch (error) {
      return dateString
    }
  }

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR',
    }).format(amount || 0)
  }

  return {
    formatDate,
    formatDateTime,
    formatAmount,
    formatCurrency,
  }
}
